// Shared slim scrollbar formula — single source of truth, matches Dashboard.jsx's
// original colors exactly (confirmed against its real code, 2026-08-19 — a first
// pass here used a different/darker grey by mistake, corrected after checking).
// Used by Dashboard.jsx and every Inbox scrollable panel (InboxAll.jsx's
// conversation list, ChatBox.jsx, InboxSettings.jsx, ChatInfo.jsx). Extracted
// after the same object was independently copy-pasted into 7 places across 5
// files — one stale copy (InboxAll.jsx) silently kept overriding a real fix
// attempted elsewhere, exactly the class of bug a single shared constant prevents.
// Import and spread this instead of writing a new inline copy.
//
// 6px webkit width, thin Firefox, native step-arrow buttons explicitly hidden so
// they never show regardless of browser/OS theme.
export const slimScrollbarSx = {
  scrollbarWidth: "thin",
  scrollbarColor: (theme) =>
    theme.palette.mode === "dark" ? "#404040 #121212" : "#bdbdbd transparent",
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: (theme) => (theme.palette.mode === "dark" ? "#121212" : "transparent"),
  },
  "&::-webkit-scrollbar-thumb": {
    // Eased back lighter from the previous darken (Rahim, 2026-08-19) — a
    // middle ground between the original #ccc and the too-dark #a8a8a8.
    backgroundColor: (theme) => (theme.palette.mode === "dark" ? "#404040" : "#bdbdbd"),
    borderRadius: "0",
  },
  // The bare "&::-webkit-scrollbar-button" rule alone does NOT reliably hide the
  // native step-arrows in Chromium — a real triangle was still rendering above the
  // thumb (Rahim, 2026-08-19, confirmed via screenshot after the bare rule tested
  // as computed display:none but the arrow was still visibly painted). Chromium
  // renders 4 distinct button pseudo-elements by orientation/position; each needs
  // its own explicit display:none + zero size.
  "&::-webkit-scrollbar-button:single-button": {
    display: "none",
    width: 0,
    height: 0,
  },
  "&::-webkit-scrollbar-button:vertical:start:decrement, &::-webkit-scrollbar-button:vertical:end:increment, &::-webkit-scrollbar-button:horizontal:start:decrement, &::-webkit-scrollbar-button:horizontal:end:increment": {
    display: "none",
    width: 0,
    height: 0,
  },
};
